import { StorageService } from "../../../services/storage.service";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IFormInvoices } from "../invoices/invoices.model";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class InvoicesService {
  header = new HttpHeaders({ "Content-Type": "application/json" });
  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) {}

  getForms(appid: string) {
    const uriConnection = `${environment.exhibition_api.base_url}/${appid}/forms/invoices`;
    let headers = this.header;
    return this.http.get<{ data: IFormInvoices[] }>(`${uriConnection}`, {
      headers,
    });
  }

  getForm(appid: string, id: string): Observable<IFormInvoices> {
    let headers = this.header;
    const uri = `${environment.exhibition_api.base_url}/${appid}/form/invoices/${id}`;
    return this.http.get<IFormInvoices>(uri, { headers });
  }

  putForm(form: IFormInvoices, app_id: string) {
    const uriConnection = `${environment.exhibition_api.base_url}/${app_id}/form/invoices`;
    return this.http.put<IFormInvoices>(
      `${uriConnection}/${form.id || "default"}`,
      form
    );
  }

  // getInvoices(
  //   appid: string,
  //   hasParameters: boolean = false,
  //   parameters?: {
  //     uid?: string;
  //     createAt_start?: Date;
  //     createAt_end?: Date;
  //     status?: string;
  //     exhibition_name?: string;
  //   }
  // ) {
  //   const httpParameters =
  //     hasParameters && parameters
  //       ? Object.entries(parameters).reduce((params, [key, value]) => {
  //           if (value !== undefined && value !== null) {
  //             const formattedValue =
  //               value instanceof Date ? value.toISOString() : value.toString();
  //             return params.set(key, formattedValue);
  //           }
  //           return params;
  //         }, new HttpParams())
  //       : new HttpParams();

  //   const uriConnection = `${environment.exhibition_api.base_url}/${appid}/invoices`;
  //   let headers = this.header;
  //   return this.http.get<{ data: IInvoice[] }>(`${uriConnection}`, {
  //     headers,
  //     params: httpParameters,
  //   });
  // }

  // getInvoice(
  //   appid: string,
  //   invoice_id: string,
  //   userId: string
  // ): Observable<IInvoice> {
  //   let headers = this.header;
  //   const account = this.storageService.get("account");

  //   const uri = `${environment.exhibition_api.base_url}/${appid}/users/${userId}/invoices/${invoice_id}`;
  //   return this.http.get<IInvoice>(uri, { headers });
  // }

  // updateInvoicesStatus(
  //   appid: string,
  //   uid: string,
  //   invoice_id: string,
  //   newStatus: ChallengeStatusType,
  //   dataConfirmation?
  // ) {
  //   let headers = this.header;
  //   const data = {
  //     status: newStatus,
  //     rejectionCause: dataConfirmation.rejectionCause,
  //     comment: dataConfirmation.comment,
  //   };

  //   const uri = `${environment.exhibition_api.base_url}/${appid}/users/${uid}/invoices/${invoice_id}`;
  //   return this.http.put<IInvoice>(uri, data, { headers });
  // }
}
